"use client";
import * as React from "react";
import { Header } from "./Header";
import { ExpandableDescription } from "./ExpandableDescription";
import { getContent } from "@/lib/reactutils";
import { ContentType } from "@/interfaces/property";
import Overlay from "./Overlay";
import {
  IPropertyResult,
  IPropertyProfile,
  instanceOfProperty,
} from "@/interfaces/property";

const HeaderAndDescription: React.FC<{
  headerInfo: IPropertyProfile | IPropertyResult;
  headerType: "profile" | "property";
}> = ({ headerInfo, headerType }) => {
  const [isOverlayOpen, setIsOverlayOpen] = React.useState(false); // State to manage Overlay visibility

  const toggleOverlay = () => {
    setIsOverlayOpen((prev) => !prev); // Toggle the Overlay visibility
  };

  return (
    <div id="HeaderAndDescription"
        className="w-full flex flex-col gap-[0px] md:gap-[-6px] px-[8px] md:px-[0px]">
        
      {instanceOfProperty(headerInfo) ? (
        <>
          <Header
            headerType={headerType}
            propertyId={headerInfo.uid}
            headerName={headerInfo.name}
            hostId={headerInfo.profile.id}
            hostName={headerInfo.profile.name}
            headerImage={
              headerInfo.photo
                ? headerInfo.photo.url
                : "/assets/img/logo.png"
            }
            headerWebsite={headerInfo.website}
          />
          {/*<ExpandableDescription description={headerInfo.description} />*/}
          <section id="PropertyDescription" className="w-full">
            <div id="Description (button)"
              onClick={toggleOverlay}
              className="text-sm md:text-md cursor-pointer mt-[-8px] md:mt-[-6px] line-clamp-2 max-sm:line-clamp-2">
              {getContent(ContentType.MAIN, headerInfo.description)}
            </div>
          </section>
      
          {/* Overlay Component */}
          <Overlay
            title={headerInfo.name}
            isOpen={isOverlayOpen}
            onClose={() => setIsOverlayOpen(false)} // Close the Overlay
          >
            <p>{getContent(ContentType.MAIN, headerInfo.description)}</p> {/* Pass the description content */}
          </Overlay>
        </>
      ) : (
        <>
          <Header
            headerType={headerType}
            propertyId={headerInfo.id}
            headerName={headerInfo.name}
            hostId={headerInfo.id}
            hostName={headerInfo.name}
            headerImage={
              headerInfo.photo
                ? headerInfo.photo.url
                : "/assets/img/logo.png"
            }
            headerWebsite={headerInfo.website}
          />
          {/* <ExpandableDescription description={headerInfo.bio} /> */}
        </>
      )}
  </div>
  );
};
export default HeaderAndDescription;
